import { getDeviceInfo } from '@this/src/util/browser/device.util';

type Platform = 'ios' | 'android';

type BannerDismissedData = {
  dismissedAt: string;
  platform: Platform;
  permanent?: boolean;
};

const STORAGE_KEY = 'app_banner_dismissed';
const DISMISS_DURATION_DAYS = 7;

export const getBannerDismissedData = (): BannerDismissedData | null => {
  if (typeof localStorage === 'undefined') return null;

  const data = localStorage.getItem(STORAGE_KEY);
  if (!data) return null;

  try {
    return JSON.parse(data) as BannerDismissedData;
  } catch {
    return null;
  }
};

export const setBannerDismissed = (platform: Platform, permanent = false): void => {
  if (typeof localStorage === 'undefined') return;

  const data: BannerDismissedData = {
    dismissedAt: new Date().toISOString(),
    platform,
    permanent
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const isBannerDismissed = (): boolean => {
  const data = getBannerDismissedData();
  if (!data) return false;

  const { platform: storedPlatform, dismissedAt: storedAt, permanent } = data;
  const currentPlatform = getDeviceInfo().platform;
  if (storedPlatform !== currentPlatform) return false;

  // 無期限で非表示にした場合は常に非表示
  if (permanent) return true;

  const dismissedAt = new Date(storedAt);
  const now = new Date();
  const diffDays = (now.getTime() - dismissedAt.getTime()) / (1000 * 60 * 60 * 24);

  return diffDays < DISMISS_DURATION_DAYS;
};

export const clearBannerDismissed = (): void => {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(STORAGE_KEY);
};
